"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltiptext = exports.Tooltip = exports.MultiTooltiptext = exports.MultiTooltip = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Tooltiptext = (0, _styledComponents["default"])("span").attrs({
  className: 'flexi-tooltip-text'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  visibility: hidden;\n  width: ", ";\n  color: #fff;\n  text-align: center;\n  position: absolute;\n  z-index: 9999;\n  font-size: 12px;\n  opacity: 0;\n  transition: ", ";\n\n  ", "\n  padding: ", ";\n  ", "\n  ", "\n\n\n  \n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.theme.PrimaryTransition;
}, function (props) {
  return props.arrow && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      &:after {\n        position: absolute;\n        border-width: 7px;\n        border-style: solid;\n      }\n    "])));
}, function (props) {
  return props.pad;
}, function (props) {
  return props.round && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      border-radius: ", ";\n    "])), function (props) {
    return props.round;
  });
}, function (props) {
  return props.background && (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      background: ", ";\n    "])), function (props) {
    return props.background;
  });
}, function (props) {
  return props.left && (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      top: ", ";\n      right: 125%;\n      &:after {\n        content: \"\";\n        top: 45%;\n        left: 100%;\n        margin-top: -5px;\n        border-color: transparent transparent transparent\n          ", ";\n      }\n    "])), function (props) {
    return props.theme.SecondaryRadius;
  }, function (props) {
    return props.background;
  });
}, function (props) {
  return props.right && (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      top: ", ";\n      left: 130%;\n      &:after {\n        content: \"\";\n        top: 45%;\n        right: 100%;\n        margin-top: -5px;\n        border-color: transparent ", " transparent\n          transparent;\n      }\n    "])), function (props) {
    return props.theme.SecondaryRadius;
  }, function (props) {
    return props.background;
  });
}, function (props) {
  return props.top && (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      bottom: 130%;\n      left: 50%;\n      margin-left: -60px;\n      &:after {\n        content: \"\";\n        top: 100%;\n        left: 50%;\n        margin-left: -5px;\n        border-color: ", " transparent transparent\n          transparent;\n      }\n    "])), function (props) {
    return props.background;
  });
}, function (props) {
  return props.bottom && (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      top: 130%;\n      left: 50%;\n      margin-left: -60px;\n      &:after {\n        content: \"\";\n        bottom: 100%;\n        left: 50%;\n        margin-left: -5px;\n        border-color: transparent transparent ", "\n          transparent;\n      }\n    "])), function (props) {
    return props.background;
  });
});
exports.Tooltiptext = Tooltiptext;
var Tooltip = (0, _styledComponents["default"])("div").attrs({
  className: 'flexi-tooltip'
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  &:hover ", " {\n    visibility: visible;\n    opacity: 1;\n  }\n\n  width: ", ";\n  ", "\n"])), Tooltiptext, function (props) {
  return props.width;
}, function (props) {
  return props.margin && (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n      margin: ", ";\n    "])), function (props) {
    return props.margin;
  });
});
exports.Tooltip = Tooltip;
var MultiTooltiptext = (0, _styledComponents["default"])("span").attrs({
  className: 'flexi-multi-tooltip-text'
})(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  visibility: hidden;\n  color: #fff;\n  width: ", ";\n  text-align: left;\n  position: absolute;\n  z-index: 9999;\n  font-size: 12px;\n  opacity: 0.5;\n  transition: ", ";\n  pointer-events: auto;\n  padding: ", ";\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.theme.PrimaryTransition;
}, function (props) {
  return props.pad;
}, function (props) {
  return props.arrow && (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n      &:after {\n        position: absolute;\n        border-width: 7px;\n        border-style: solid;\n      }\n    "])));
}, function (props) {
  return props.round && (0, _styledComponents.css)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n      border-radius: ", ";\n    "])), function (props) {
    return props.round;
  });
}, function (props) {
  return props.background && (0, _styledComponents.css)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      background: ", ";\n    "])), function (props) {
    return props.background;
  });
}, function (props) {
  return props.rightStart && (0, _styledComponents.css)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n      top: 0;\n      left: 120%;\n      &:after {\n        content: \"\";\n        top: 15%;\n        right: 100%;\n        margin-top: -5px;\n        border-color: transparent ", " transparent\n          transparent;\n      }\n    "])), function (props) {
    return props.background;
  });
}, function (props) {
  return props.rightEnd && (0, _styledComponents.css)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n      bottom: 0;\n      left: 120%;\n      &:after {\n        content: \"\";\n        bottom: 15%;\n        right: 100%;\n        margin-top: -5px;\n        border-color: transparent ", " transparent\n          transparent;\n      }\n    "])), function (props) {
    return props.background;
  });
}, function (props) {
  return props.leftStart && (0, _styledComponents.css)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n      top: 0;\n      right: 120%;\n      &:after {\n        content: \"\";\n        top: 15%;\n        left: 100%;\n        margin-top: -5px;\n        border-color: transparent transparent transparent\n          ", ";\n      }\n    "])), function (props) {
    return props.background;
  });
}, function (props) {
  return props.leftEnd && (0, _styledComponents.css)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n      bottom: 0;\n      right: 120%;\n      &:after {\n        content: \"\";\n        bottom: 15%;\n        left: 100%;\n        margin-top: -5px;\n        border-color: transparent transparent transparent\n          ", ";\n      }\n    "])), function (props) {
    return props.background;
  });
}, function (props) {
  return props.topStart && (0, _styledComponents.css)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n      bottom: 140%;\n      left: 0;\n      margin-left: 0;\n      &:after {\n        content: \"\";\n        top: 100%;\n        left: 10%;\n        margin-left: -5px;\n        border-color: ", " transparent transparent\n          transparent;\n      }\n    "])), function (props) {
    return props.background;
  });
}, function (props) {
  return props.topEnd && (0, _styledComponents.css)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n      bottom: 140%;\n      right: 0;\n      margin-left: -60px;\n      &:after {\n        content: \"\";\n        top: 100%;\n        right: 10%;\n        margin-left: -5px;\n        border-color: ", " transparent transparent\n          transparent;\n      }\n    "])), function (props) {
    return props.background;
  });
}, function (props) {
  return props.bottomStart && (0, _styledComponents.css)(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n      top: 140%;\n      left: 0;\n      margin-left: 0;\n      &:after {\n        content: \"\";\n        bottom: 100%;\n        left: 10%;\n        margin-left: -5px;\n        border-color: transparent transparent\n          ", " transparent;\n      }\n    "])), function (props) {
    return props.theme.PrimaryFontColor;
  });
}, function (props) {
  return props.bottomEnd && (0, _styledComponents.css)(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n      top: 140%;\n      right: 0;\n      margin-left: -60px;\n      &:after {\n        content: \"\";\n        bottom: 100%;\n        right: 10%;\n        margin-left: -5px;\n        border-color: transparent transparent ", "\n          transparent;\n      }\n    "])), function (props) {
    return props.background;
  });
});
exports.MultiTooltiptext = MultiTooltiptext;
var MultiTooltip = (0, _styledComponents["default"])("div").attrs({
  className: 'flexi-multi-tooltip'
})(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  &:hover ", " {\n    visibility: visible;\n    opacity: 1;\n  }\n\n  width: ", ";\n\n  ", "\n"])), MultiTooltiptext, function (props) {
  return props.width;
}, function (props) {
  return props.margin && (0, _styledComponents.css)(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n      margin: ", ";\n    "])), function (props) {
    return props.margin;
  });
});
exports.MultiTooltip = MultiTooltip;
Tooltip.propTypes = {
  width: _propTypes["default"].any,
  margin: _propTypes["default"].any
};
Tooltip.defaultProps = {
  width: "max-content",
  margin: 0
};
MultiTooltip.propTypes = {
  width: _propTypes["default"].any,
  margin: _propTypes["default"].any
};
MultiTooltip.defaultProps = {
  width: "max-content",
  margin: 0
};
Tooltiptext.propTypes = {
  right: _propTypes["default"].bool,
  left: _propTypes["default"].bool,
  top: _propTypes["default"].bool,
  bottom: _propTypes["default"].bool,
  arrow: _propTypes["default"].bool,
  pad: _propTypes["default"].any,
  round: _propTypes["default"].any,
  width: _propTypes["default"].any
};
Tooltiptext.defaultProps = {
  right: false,
  left: false,
  top: false,
  bottom: false,
  arrow: true,
  pad: "8px 0",
  round: "5px",
  background: function background(props) {
    return props.theme.PrimaryFontColor;
  },
  width: "120px"
};
MultiTooltiptext.propTypes = {
  rightStart: _propTypes["default"].bool,
  rightEnd: _propTypes["default"].bool,
  leftStart: _propTypes["default"].bool,
  leftEnd: _propTypes["default"].bool,
  topStart: _propTypes["default"].bool,
  topEnd: _propTypes["default"].bool,
  bottomStart: _propTypes["default"].bool,
  bottomEnd: _propTypes["default"].bool,
  arrow: _propTypes["default"].bool,
  pad: _propTypes["default"].any,
  round: _propTypes["default"].any,
  width: _propTypes["default"].any
};
MultiTooltiptext.defaultProps = {
  rightStart: false,
  rightEnd: false,
  leftStart: false,
  leftEnd: false,
  topStart: false,
  topEnd: false,
  bottomStart: false,
  bottomEnd: false,
  arrow: true,
  pad: "13px 15px",
  round: "5px",
  background: function background(props) {
    return props.theme.PrimaryFontColor;
  },
  width: "300px"
};